import React from 'react';

import {
  List,
} from '@mui/material';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';

import CustomListItem from '@/components/CustomListItem';
import { Birthday } from '@/domain/childApply/service/entity/valueObjects/birthday';
import { Gender } from '@/domain/childApply/service/entity/valueObjects/gender';
import { toStringDateDisplay } from '@/utils/date';

const ChildInfo: React.FC<{
  /** データ */
  data: ChildJson,
}> = ({ data }) => {
  const {
    name,
    nameKana,
    familyName,
    familyNameKana,
  } = data;
  return (
    <List>
      <CustomListItem
        name="氏名"
        content={`${familyName} ${name}`}
        secondary={`${familyNameKana} ${nameKana}`}
      />
      <CustomListItem name={Gender.label} content={data.gender.toString()} />
      <CustomListItem
        name={Birthday.label}
        content={toStringDateDisplay(new Date(data.birthday), false)}
      />
    </List>
  );
};

export default ChildInfo;
